import { getApolloClient } from '$apollo/util';
import type { CmsAreaItem } from '$cms/types';
import { removeNullValues } from '$util/basic';
import type { AnyObject } from '$util/types';
import type {
  QueryFetchAreaCollectionData,
  QueryFetchAreaCollectionDataVariables,
} from './gql/queries/queryFetchAreaCollectionData';
import { QUERY_FETCH_AREA_COLLECTION_DATA } from './gql/queries/queryFetchAreaCollectionData';

type FetchAreaCollectionDataContext = AnyObject & {
  readonly headers?: AnyObject;
};

export async function fetchAreaCollectionsData(
  { filter, segment, preview, limit = 20 }: QueryFetchAreaCollectionDataVariables,
  context?: FetchAreaCollectionDataContext
): Promise<CmsAreaItem[]> {
  const apollo = getApolloClient();
  const { data } = await apollo.query<QueryFetchAreaCollectionData, QueryFetchAreaCollectionDataVariables>({
    query: QUERY_FETCH_AREA_COLLECTION_DATA,
    variables: {
      filter,
      segment,
      preview,
      limit,
    },
    context: {
      needsAuthentication: false,
      ...context,
    },
    fetchPolicy: 'no-cache',
  });

  return removeNullValues(data?.getCmsAreas) || [];
}
